import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export function gnav() {
    const gnav = document.querySelector(".l-gnav");
    const open = document.querySelector(".js-gnav_open");
    const close = document.querySelectorAll(".js-gnav_close");

    //要素がない場合は終了
    if (!gnav) {
        return;
    }

    open.addEventListener("click", () => {
        document.body.classList.add("-gnav_active");
    });

    close.forEach(function (elm) {
        elm.addEventListener("click", () => {
            document.body.classList.remove("-gnav_active");
        });
    });

    // カレント表示用
    const section = document.querySelectorAll(".js-section");

    section.forEach((el) => {
        const changeCurrent = () => {
            const sec = el.id;
            document.body.dataset.current = sec;

            //パフォーマンス的にあまり良くないがここで再計算させる。tabfuncでのrefreshで足りないため
            ScrollTrigger.refresh();
        };

        ScrollTrigger.create({
            trigger: el,
            start: "top center",
            end: "bottom center",
            //markers: true,
            onEnter: () => {
                changeCurrent();
            },
            onEnterBack: () => {
                changeCurrent();
            },
        });
    });
}
